import { insertSpacingRule } from "./styles";
import _get from "lodash/get";

import { baseUrl } from "../../util/service";

import {
    getNewsletters,
    getAvailableArchives,
    getNewsletterData,
    getTemporaryNewsletterData,
} from "@publicrelay/service/dist/nest/newsletters";

/**
 * Redux Action (thunk) that invokes the get newsletters service
 * @param {string} accessToken
 * @returns {Function}
 */
export const loadNewsletters = accessToken => (dispatch, getState) => {
    getNewsletters({ accessToken: accessToken, baseUrl: baseUrl })
        .then(response => {
            dispatch({
                type: "newsletters/LOAD_NEWSLETTERS_SUCCESS",
                payload: _get(response, "newsletters", []),
            });
        })
        .catch(error => {
            dispatch({
                type: "newsletters/LOAD_NEWSLETTERS_ERROR",
                payload: error,
            });
        });
};

/**
 * Redux Action (thunk) that invokes the get archives service for a specific newsletter
 * @param {string} accessToken
 * @param {string} groupingId
 * @returns {Function}
 */
export const loadAvailableArchives = (accessToken, groupingId) => (
    dispatch,
    getState
) => {
    getAvailableArchives({
        accessToken: accessToken,
        groupingId: groupingId,
        baseUrl: baseUrl,
    })
        .then(response => {
            dispatch({
                type: "newsletters/LOAD_AVAILABLE_ARCHIVES_SUCCESS",
                payload: response,
            });
        })
        .catch(error => {
            dispatch({
                type: "newsletters/LOAD_AVAILABLE_ARCHIVES_ERROR",
                payload: error,
            });
        });
};

/**
 * Redux Action (thunk) that invokes the get newsletter data service for a specific newsletter edition/date
 * @param {string} accessToken
 * @param {string} groupingId
 * @param {string} edition
 * @returns {Function}
 */
export const loadNewsletterData = (accessToken, groupingId, edition) => (
    dispatch,
    getState
) => {
    getNewsletterData({
        accessToken: accessToken,
        groupingId: groupingId,
        edition: edition,
        baseUrl: baseUrl,
    })
        .then(response => {
            dispatch({
                type: "newsletters/LOAD_NEWSLETTER_DATA_SUCCESS",
                payload: response,
            });
        })
        .catch(error => {
            dispatch({
                type: "newsletters/LOAD_NEWSLETTER_DATA_ERROR",
                payload: error,
            });
        })
        .finally(() => {
            const state = getState();
            const action = insertSpacingRule(state);
            dispatch(action);
        });
};

/**
 * Redux Action (thunk) that invokes the get temporary newsletter data service for a specific newsletter edition/date
 * @param {string} accessToken
 * @param {string} groupingId
 * @param {string} newsletterTempId
 * @returns {Function}
 */
export const loadTemporaryNewsletterData = (
    accessToken,
    groupingId,
    newsletterTempId
) => (dispatch, getState) => {
    getTemporaryNewsletterData({
        accessToken: accessToken,
        groupingId: groupingId,
        newsletterTempId: newsletterTempId,
        baseUrl: baseUrl,
    })
        .then(response => {
            dispatch({
                type: "newsletters/LOAD_TEMPORARY_NEWSLETTER_DATA_SUCCESS",
                payload: response,
            });
        })
        .catch(error => {
            dispatch({
                type: "newsletters/LOAD_TEMPORARY_NEWSLETTER_DATA_ERROR",
                payload: error,
            });
        })
        .finally(() => {
            const state = getState();
            const action = insertSpacingRule(state);
            dispatch(action);
        });
};
